const config = {
    build_number: '615201',
    build_timestamp: '2026-08-07T18:22:40.090Z',
    build_commit: 'af5f234cbf78fbb74e6d372045e91c716cfe7bb5',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
